export default "__VITE_ASSET__DiE11mqm__"